import { Model, Store } from 'store/Base';
import { observable } from 'mobx';

export const TICKET_SPRINT_STATUS_TODO = 'todo';
export const TICKET_SPRINT_STATUS_IN_PROGRESS = 'in_progress';
export const TICKET_SPRINT_STATUS_REVIEW = 'review';
export const TICKET_SPRINT_STATUS_DONE = 'done';

export const TICKET_SPRINT_STATUSES = [
    TICKET_SPRINT_STATUS_TODO,
    TICKET_SPRINT_STATUS_IN_PROGRESS,
    TICKET_SPRINT_STATUS_REVIEW,
    TICKET_SPRINT_STATUS_DONE,
];

export class TicketSprintAssignment extends Model {
    static backendResourceName = 'ticket_sprint_assignment';

    @observable id = null;
    @observable sprint: any = null;
    @observable ticket: any = null;
    @observable assignee: any = null;
    @observable plannedHours = 0;
    @observable status = TICKET_SPRINT_STATUS_TODO;
    @observable order = 0;
}

export class TicketSprintAssignmentStore extends Store {
    Model = TicketSprintAssignment;
    static backendResourceName = 'ticket_sprint_assignment';
}
